import React from 'react';
import TestGraphSettings from './TestGraphSettings';

// Modal shell that wraps the reusable TestGraphSettings component so the
// Test Cases page can edit run settings without leaving the page. The
// settings object lives in the parent (TestCasesPage state +
// localStorage), so closing the modal keeps every change.

function RunSettingsModal({
  isOpen,
  onClose,
  settings,
  onSettingsChange,
  graphId,
  workspaceId,
}) {
  if (!isOpen) return null;

  return (
    <div className="tc-modal-backdrop" onClick={onClose}>
      <div
        className="tc-modal"
        style={{ width: 'min(1100px, 100%)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tc-modal-header">
          <h2>Run Settings</h2>
          <button type="button" className="btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="tc-modal-body" style={{ padding: 0 }}>
          <TestGraphSettings
            settings={settings}
            onSettingsChange={onSettingsChange}
            collapsed={false}
            onToggleCollapse={() => {}}
            graphId={graphId}
            workspaceId={workspaceId}
          />
        </div>
        <div className="tc-modal-footer">
          <button type="button" className="btn-primary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

export default RunSettingsModal;
